import { useApolloClient } from '@apollo/client'
import { AuthenticatePartner, PartnerSignInToken } from 'services/gql/authenticatePartner/mutation'

export const useAuthenticatePartnerService = () => {
    const client = useApolloClient()

    const authenticatExtenalCompany = async (
        federalTaxId: string,
        token: string,
    ): Promise<{ access_token: string; refresh_token: string }> => {
        const {
            data: { authenticatePartner },
        } = await client.mutate({
            mutation: AuthenticatePartner,
            variables: {
                federalTaxId,
            },
            context: {
                headers: {
                    authorization: `Bearer ${token}`,
                },
            },
        })

        return authenticatePartner
    }

    const getPartnerSignInToken = async (nanoId: string): Promise<{ token: string }> => {
        const {
            data: { partnerSignInToken },
        } = await client.mutate({
            mutation: PartnerSignInToken,
            variables: {
                nanoId,
            },
        })

        return partnerSignInToken
    }

    return {
        authenticatExtenalCompany,
        getPartnerSignInToken,
    }
}
